import { Component, Input } from '@angular/core';

@Component({
  selector: 'ocf-form-pending-notices',
  template: `
    @if (contactsPending && !filesPending) {
      <ocf-alert type="warning" i18n> Please finish editing contact list before saving or submitting the form. </ocf-alert>
    }

    @if (!contactsPending && filesPending) {
      <ocf-alert type="warning" i18n> Please wait for files to finish uploading before saving or submitting the form. </ocf-alert>
    }

    @if (contactsPending && filesPending) {
      <ocf-alert type="warning" i18n>
        Please wait for files to finish uploading and complete filling out "additional contacts" before saving or submitting the form.
      </ocf-alert>
    }
  `,
  standalone: false,
})
export class OcfFormPendingNoticesComponent {
  @Input() contactsPending = false;
  @Input() filesPending = false;
}
